export default __webpack_public_path__ + "static/media/ww7.e6576f1a.jpg";